module.exports = __webpack_public_path__ + "static/images/styles/images/button-small/bsm-secondary-bg-right.060c5427.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/button-small/bsm-secondary-bg-right.png
// module id = 3605
// module chunks = 11